import { Component } from '@angular/core';
import { ButtonModule } from '@components/button/button.module';
import { AppConfigService } from '@services/app-config.service';
import { AppTrackingService } from '@services/app-tracking.service';
import { ScreenService } from '@services/screen.service';
import { TranslationService } from '@services/translation.service';

@Component({
  selector: 'app-cookies-disclaimer',
  templateUrl: 'cookies-disclaimer.component.html',
  styleUrls: ['cookies-disclaimer.component.scss'],
  standalone: true,
  imports: [ButtonModule],
})
export class CookiesDisclaimerComponent {
  constructor(
    public appConfig: AppConfigService,
    public appTrackingService: AppTrackingService,
    public screenService: ScreenService,
    public ts : TranslationService
  ) {}
}
